<template>
  <header class="main-navigation" v-if="canDisplay" :class="{'main-navigation--column-reverse': me.id }">
    <h1 class="main-navigation__logo">
      <router-link data-v-home-step="0" data-v-long-step="0" style="color: white" :to="{ name: 'Home' }">
        <img src="/static/images/logo-parkave.png" alt="ParkAve" />
      </router-link>
    </h1>
    <!-- <p v-if="me.id == null" class="main-navigation__sign-in">Already a user? <span v-on:click="showIntersection" class="main-navigation__sign-in__link link">Sign in</span></p> -->
    <span v-if="me.id == null && !getShareCode()" v-on:click="showIntersection" class="main-navigation__sign-up button button--primary">Sign In</span>
    <p class="main-navigation__links" v-if="me.id" style="color: white;">
      <span class="member-nav">
        <router-link data-v-home-step="5" :to="{ name: 'Ads' }">My Creatives</router-link>
        <router-link data-v-long-step="1" to="/" exact>Browse formats</router-link>
          <a href="#" @click="openVideoModal" class="router-link">Explainer Video (Tutorial)</a>
      </span>
    </p>

    <!--
    When user toggles dropdown the following classes/modifiers should be set:
    * user-profile__user-name--active
    * user-profile__list--visible

    For now I've enabled them so you can see the proper state
    -->
    <div v-if="me.id" class="main-navigation__user-profile user-profile">
      <span class="user-profile__user-name" v-click-outside="closeMenu" @click="profileActive = !profileActive" v-bind:class="{'user-profile__user-name--active': profileActive}">{{account.name}}</span>
      <ul class="user-profile__list" v-bind:class="{'user-profile__list--visible': profileActive}">
        <li class="user-profile__item"><span class="user-profile__link user-profile__item-title user-profile__item-title--top">Accounts</span></li>
        <li class="user-profile__item user-profile__item--hover" v-for="account in accounts" @click="profileActive = !profileActive"><span class="user-profile__link" v-on:click="switchAccount(account)">{{ account.name }}</span></li>
        <li class="user-profile__item"><span class="user-profile__link user-profile__item-title">Settings</span></li>
        <li class="user-profile__item user-profile__item--hover" @click="profileActive = !profileActive"><router-link class="user-profile__link" :to="{ name: 'Profile' }">Account Settings</router-link></li>
        <li class="user-profile__item user-profile__item--hover" v-if="userIsSuperAdmin" @click="profileActive = !profileActive"><router-link class="user-profile__link" :to="{ name: 'Administrator' }">Admin Controls</router-link></li>
        <li class="user-profile__item user-profile__item--hover" v-if="isMocked" @click="removeAdminMocking"><router-link class="user-profile__link" :to="{ name: 'Administrator' }">Remove Admin Mock</router-link></li>
        <li class="user-profile__item user-profile__logout"><span class="button button--tertiary button--expand user-profile__item--hover" v-if="me.id" v-on:click="logout">Logout</span></li>
      </ul>
    </div>

    <span v-if="!isAppStandalone()" v-on:click="exit" class="main-navigation__close close">Close</span>
  </header>
</template>

<script>
import { logout } from '../../lib/api/calls'
import { close } from '../../lib/integration'
import {mapState} from 'vuex'

export default {
  name: 'main-navigation',
  methods: {
    closeMenu() {
      if (this.profileActive) {
        this.profileActive = false
      }
    },
    showSignIn () {
      this.$modal.show('sign-in')
    },
    showIntersection () {
      this.$modal.show('intersection')
    },
    logout(){
      logout();
    },
    switchAccount(account) {
      this.$store.dispatch('setAccount', account);
    },
    exit () {
      close();
    },
    removeAdminMocking () {
      this.profileActive = !this.profileActive;
      delete localStorage.user_id;
      this.$store.dispatch('reloadMe');
    },
    openVideoModal () {
      this.$modal.show('video', {title: 'ParkAve: Crash Course', video: 'https://www.youtube.com/embed/LDDeb8WdZoQ'});
    }
  },
  computed: {
    ...mapState(['adminMocking', 'me']),
    userIsSuperAdmin () {
      return this.me.admin || this.me.format_admin;
    },
    account() {
      return this.$store.state.account
    },
    accounts() {
      return this.$store.getters['accounts/owned']
    },
    isMocked() {
      return this.adminMocking;
    },
    canDisplay () {
      return this.$route.name !== 'Demo' && this.$route.name !== 'EnterpriseForm' && this.$route.name !== 'UpdateSuccess' && this.$route.name !== 'Self Serve Updates'
    }
  },
  data () {
    return {
      profileActive: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/MainNavigation.vue